import React, { lazy } from 'react'
import { DashSwitch } from '@retailer-platform/dashboard/routing'
import { DomainRoute } from '../utils/domain/routingComponents'
import { aioliAccessControl } from '../access-control/aioliAccess.configuration'

const AioliPage = lazy(() => import(/* webpackChunkName: "AioliPage" */ '../pages/AioliPage'))

// @hygen:inject page-import

// Note that this is intentionally not a component. Do not wrap <DomainRoute> with anything else, as it will cause issues with the parent <Switch />
// More information here https://v5.reactrouter.com/web/api/Switch/children-node
export const aioliRouter = (
  <DomainRoute route="aioli" accessControl={aioliAccessControl}>
    <DashSwitch>
      <DomainRoute exact route="aioli" component={AioliPage} />
      {/* @hygen:inject router-route
        injection point for routes, please do not delete */}
    </DashSwitch>
  </DomainRoute>
)
